import { AdminScreen } from '@/screens/admin/admin-screen'

export default function () {
  return <AdminScreen />
}
